import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'

const fbConfig = {
  apiKey: "AIzaSyBIpjpHCBwQYurN1u-U-TZkyndqbDlNi54",
  authDomain: "drive-77553.firebaseapp.com",
  databaseURL: "https://drive-77553.firebaseio.com",
  projectId: "drive-77553",
  storageBucket: "drive-77553.appspot.com",
  messagingSenderId: "474243254245",
  appId: "1:474243254245:web:1a53aaaf3a9b02f50dd10c"
};

firebase.initializeApp(fbConfig)
var db = firebase.firestore()
const storage  = firebase.storage()
//const auth = firebase.auth()


const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true
}

export { firebase, db, storage }